import { Guardian } from '@xaamin/guardian';

Guardian.define('developer.request.facturas', (user) => {
  return user.can('developer.request.facturas');
});

Guardian.define('developer.request.retenciones', (user) => {
  return user.can('developer.request.retenciones');
});

Guardian.define('developer.logs.app', (user) => {
  return user.can('developer.logs.app');
});

Guardian.define('developer.logs.system', (user) => {
  return user.can('developer.logs.system');
});
